import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPagoUnicoCATAByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetPagoUnicoCATAByUser = () => {
  const [loadingGetPagoUnicoCATAByUser, setLoadingGetPagoUnicoCATAByUser] = useState(false);
  const [successGetPagoUnicoCATAByUser, setSuccessGetPagoUnicoCATAByUser] = useState(false);
  const [errorGetPagoUnicoCATAByUser, setErrorGetPagoUnicoCATAByUser] = useState<any>(null);
  const [dataGetPagoUnicoCATAByUser, setDataPagoUnicoCATAByUser] = useState<any>(null);

  const [statusGetPagoUnicoCATAByUser, setStatusGetPagoUnicoCATAByUser] =
    useState<StatusGetPagoUnicoCATAByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPagoUnicoCATAByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPagoUnicoCATAByUser(true);
    setSuccessGetPagoUnicoCATAByUser(false);
    setErrorGetPagoUnicoCATAByUser(null);

    try {
      const res = await apirecord.getSolicitudPagoUnicoByUser(userId, expedienteId);

      setStatusGetPagoUnicoCATAByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetPagoUnicoCATAByUser(true);
      setDataPagoUnicoCATAByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPagoUnicoCATAByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetPagoUnicoCATAByUser(err);
      console.error("Error en getPagoUnicoCATAByUser:", err);

      throw err;

    } finally {
      setLoadingGetPagoUnicoCATAByUser(false);
    }
  };


  return {
    getPagoUnicoCATAByUser,
    loadingGetPagoUnicoCATAByUser,
    successGetPagoUnicoCATAByUser,
    errorGetPagoUnicoCATAByUser,
    dataGetPagoUnicoCATAByUser,
    statusGetPagoUnicoCATAByUser
  };
};

export default useGetPagoUnicoCATAByUser;
